module.exports = __webpack_public_path__ + "img/Namibia.290c90ba.svg";